export class ErrorMessageUtils {
  public static determineFrontendMessageBasedOnError(error: any): string {
    switch (error.code) {
      case 'auth/quota-exceeded':
        return 'Er is iets misgegaan. Probeer het later opnieuw.';
      case 'invalid-email':
        return 'Opgegeven email is niet geldig.';
      case 'auth/email-not-verified':
        return 'Bevestig eerst je e-mailadres via de link die we je stuurden.';
      case 'auth/email-sent-again':
        return 'Er werd opnieuw een verificatie e-mail verzonden.';
      case 'auth/user-not-found':
        return 'Er is geen gebruiker gevonden met deze e-mail.';
      // With Email Enumeration Protection on, Firebase returns invalid-credential where
      // it used to return wrong-password. The Auth emulator still returns the old code,
      // so both stay mapped.
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
      case 'auth/invalid-login-credentials':
        return 'Het opgegeven wachtwoord is niet correct.';
      case 'auth/requires-recent-login':
        return 'Log opnieuw in en probeer het daarna nogmaals.';
      case 'auth/weak-password':
        return 'Het nieuwe wachtwoord is te zwak. Gebruik minstens 6 tekens.';
      case 'auth/invalid-new-email':
        return 'Het nieuwe e-mailadres is niet geldig.';
      case 'auth/expired-action-code':
        return 'Deze link is vervallen. Vraag een nieuwe aan.';
      case 'auth/invalid-action-code':
        return 'Deze link is niet meer geldig. Vraag een nieuwe aan.';
      case 'auth/user-mismatch':
        return 'Deze gegevens horen niet bij het account waarmee je bent ingelogd.';
      case 'auth/admin-restricted-operation':
        return 'Deze actie is uitgeschakeld. Neem contact op met de club.';
      case 'account/same-email':
        return 'Dat is al je huidige e-mailadres.';
      case 'account/not-signed-in':
        return 'Je bent niet meer ingelogd. Log opnieuw in en probeer het nogmaals.';
      case 'account/partially-deleted':
        return 'Je gegevens zijn verwijderd, maar je login kon niet verwijderd worden. Neem contact op met de club.';
      case 'auth/email-already-in-use':
        return 'Er bestaat al een gebruiker met deze e-mail.';
      case 'auth/not-all-fields-filled-in':
        return 'Gelieve alle velden in te vullen.';
      case 'auth/user-disabled':
        return 'Dit account is gedeactiveerd.';
      case 'auth/too-many-requests':
        return 'Te veel pogingen. Wacht even en probeer het opnieuw.';
      case 'auth/chipnumber-invalid':
        return 'Deze chip nummer is niet geldig.';
      case 'reservation/class-full':
        return 'Deze les is volzet.';
      case 'reservation/cap-reached':
        return 'Je hebt het maximum aantal reservaties voor deze les bereikt.';
      case 'reservation/none-to-remove':
        return 'Je hebt geen reservatie voor deze les om te verwijderen.';
      case 'class/capacity-below-booked':
        return 'Er zijn al meer fietsen gereserveerd dan dit aantal. Verwijder eerst reservaties.';
      case 'reservation/trial-used':
        return 'Je gratis proefles is al gebruikt. Word lid met een chipnummer of code om verder te reserveren.';
      default:
        return 'Er is iets misgegaan. Probeer het later opnieuw.';
    }
  }
}
